import React from "react";
import { gql } from "@apollo/client";

import CmpAgGrid from "../../lib/AgGrid/CmpAgGrid";
import { contractIdFromPath } from "../../lib/Util/url";
import PropTypes from "prop-types";
import CmpAgGridLink from "../../lib/AgGrid/CmpAgGridLink";
import HORemoveFromContractBtn from "./HORemoveFromContractBtn";

class TableView extends React.Component {
  render() {
    return (
      <CmpAgGrid
        userId={this.props.currentUser.id}
        defaultColumnDefs={this.defaultColumnDefs()}
        gqlQuery={this.contractHoUsersQuery}
        responseDataKey="contractHoUsers"
        frameworkComponents={this.frameworkComponents}
        onGridReady={this.props.onGridReady}
        preserveSelection={false}
        getRowId={params => String(params.data.id)}
      />
    );
  }

  frameworkComponents = {
    removeFromContractRenderer: row => {
      if (row.data.roleOnContract === "IT Admin") {
        return null;
      }
      return (
        <HORemoveFromContractBtn
          contractId={parseInt(contractIdFromPath(), 10)}
          userId={row.data.id}
          params={row}
        />
      );
    }
  };

  defaultColumnDefs = () => [
    {
      headerName: "First Name",
      field: "firstName",
      type: "cmpLinkColumn",
      cellRenderer: CmpAgGridLink,
      cellRendererParams: params => {
        return {
          link: `/user_accounts/${params.data.id}?tab=details`
        };
      }
    },
    {
      headerName: "Last Name",
      field: "lastName",
      filter: "agTextColumnFilter"
    },
    {
      headerName: "Role on contract",
      field: "roleOnContract",
      sortable: false,
      filter: "agSetColumnFilter",
      filterParams: {
        values: [
          "IT Admin",
          "Head Office Standard",
          "Head Office Supervisor",
          "Head Office Contract Manager"
        ]
      }
    },
    {
      headerName: "Contracts",
      colId: "contract",
      field: "contracts",
      // Doesn't make sense to sort when there are multiple
      sortable: false,
      filter: "agSetColumnFilter",
      filterParams: {
        values: this.props.contractCodes,
        comparator: (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()),
        excelMode: "windows"
      }
    },
    {
      headerName: "Email",
      field: "email",
      filter: "agTextColumnFilter"
    },
    {
      headerName: "Status",
      field: "status",
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["Active", "Inactive"]
      }
    },
    {
      headerName: "Action",
      field: "action",
      sortable: false,
      filter: false,
      cellRenderer: "removeFromContractRenderer"
    }
  ];

  contractHoUsersQuery = () => {
    const id = contractIdFromPath();
    return gql`
      query ContractHoUsers($agGridParams: RequestParamInput!) {
        contractHoUsers(agGridParams: $agGridParams, contractId:${id}) {
          id
          firstName
          lastName
          email
          contracts
          roleOnContract
          status
        }
      }
    `;
  };
}

TableView.propTypes = {
  contractCodes: PropTypes.array.isRequired,
  currentUser: PropTypes.object,
  onGridReady: PropTypes.func
};

export default TableView;
